const firebaseConfig = {
    apiKey: "AIzaSyCxCPBAefvnTQjehofcPU7-RG-pvlompC0",
    authDomain: "brander-37e58.firebaseapp.com",
    projectId: "brander-37e58",
    storageBucket: "brander-37e58.appspot.com",
    messagingSenderId: "130701475187",
    appId: "1:130701475187:web:08bdf07e1d495d9741d906"
  };

  export default firebaseConfig